import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideContrast,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const WhyStructureBeatsMotivationSection = ({ heading, accentIndex = 2, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="why-structure-beats-motivation"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Many people believe they need more motivation to think clearly or make better decisions. In
      reality, motivation is temporary.
    </GuideLead>
    <p className="guide-panel__p">
      Some days you feel motivated. Other days you don't. Structure works differently. A good
      framework helps you make good decisions even when you are tired, stressed, or emotionally
      overwhelmed.
    </p>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="energy" title="Structure is the road" description="Without roads, even the fastest car cannot reach its destination." />
      <GuideCard iconKey="growth" title="Motivation is the fuel" description="You need both, but without structure, motivation often leads nowhere." />
    </GuideCardGrid>
    <p className="guide-panel__p">
      Successful leaders, athletes, doctors, and pilots rely on systems, checklists, and processes—not
      because they lack intelligence, but because structure reduces mistakes.
    </p>
    <GuideContrast
      items={[
        {
          title: "Motivation fades.",
          text: "Motivation changes from day to day.",
        },
        {
          title: "Structure endures.",
          text: "Your thinking deserves the same discipline.",
        },
      ]}
    />
    <GuideCallout variant="amber">Your thinking deserves the same discipline.</GuideCallout>
  </GuidePanel>
);

export default WhyStructureBeatsMotivationSection;
